import { render, staticRenderFns } from "./changeDutyVersion.vue?vue&type=template&id=0f9d50a0&scoped=true"
import script from "./changeDutyVersion.vue?vue&type=script&lang=js"
export * from "./changeDutyVersion.vue?vue&type=script&lang=js"
import style0 from "./changeDutyVersion.vue?vue&type=style&index=0&id=0f9d50a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d50a0",
  null
  
)

export default component.exports